import cn from 'classnames';
import { WidgetProps } from '@chewy/chat-library-common';
import UserActionButton, { UserActionButtonProps } from './UserActionButton';
import styles from './UserActionButtonPanel.module.scss';

export interface UserActionButtonPanelData {
    /** Buttons to render in the panel */
    buttons?: UserActionButtonProps[];
}

export default function UserActionButtonPanel({
    data,
    className,
    direction = 'vertical',
    disabled,
}: WidgetProps<UserActionButtonPanelData>) {
    const resolvedData = data?.[0];

    if (!resolvedData?.buttons) {
      return null;
    }

    return (
        <div
            className={cn(styles.panel, className)}
            role="group"
        >
            <div
                className={cn(styles.buttons, {
                    [styles.stacked]: direction === 'vertical',
                    [styles.horizontal]: direction === 'horizontal',
                })}
            >
                {resolvedData.buttons.map((button, index) => (
                    <UserActionButton
                        key={button.message ?? button.data?.[0]?.defaultAction?.text ?? index}
                        {...button}
                        disabled={disabled || button.disabled}
                    />
                ))}
            </div>
        </div>
    );
}
